import React from "react"
import axios from "axios";
import { latest as API_URL, lastest_insecure as API_URL_INSECURE, } from "../config/api";
import { Popconfirm, Icon, Drawer, Button, Switch, Collapse, Steps, Row, Col, Radio, message, Tag} from 'antd';
import {  panels } from "../config/Helpers";

const postUrlReports = API_URL + "reports";
const postUrlWidgets = API_URL;
const postUrlReportsInsecure = API_URL_INSECURE + "reports";

class ExportReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            visible: false,
            type_report : {},
            type_report_status : {}
        }
    }
    defaultValues(){
        let self = this,
        type_report = this.state.type_report
        
        Object.keys(type_report).map(function(key){
            self.state.type_report_status[key] = {
                name : type_report[key].name,
                status: false,
                type: 'normal'
            }
        })

        return {
            current: 0,
            visible: false
        };
    }
    componentWillMount(){
        let self = this,
        panels = this.state.panels,
        qs = require("qs");
        let params = { 
            api_token: localStorage.getItem("api_token")
        };

        axios({
            method : 'post',
            url : (self.props.app.state._is_invited === true ? (postUrlWidgets + "type-report") : (postUrlWidgets + "type-report")),
            data :  qs.stringify(params)
        }).then(function (response){
            const types = response.data
            Object.keys(types).map(function(key){
                self.state.type_report[types[key].value] = {
                    name : types[key].name,
                    status: false,
                    type: 'normal'
                }
            })
            const type_report = self.state.type_report;
            Object.keys(type_report).map(function(key){
                self.state.type_report_status[key] = {
                    name : type_report[key].name,
                    status: false,
                    type: 'normal'
                }
            })
        self.forceUpdate();
        })
    }
    next() {
        let _is_validate = false, type_report_status = this.state.type_report_status;
        
        Object.keys(type_report_status).map(function(index){
            if(type_report_status[index].status === true){
                _is_validate = true
            }
        })
        if(_is_validate){
            const current = this.state.current + 1;
            this.setState({ current });
        }else{
            message.info('SELECT AT LEAST ONE DASHBOARD TO BE ABLE TO CONTINUE WITH EXPORT', 5);
        }
    }
    
    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }
    showDrawer = () => {
        this.setState({
          visible: true,
        });
    };
    
    onClose = () => {
        this.setState(this.defaultValues());
    };

    activateDashboard = (panel, type, checked) => {
        console.log(panel, type, checked)
       this.state.type_report_status[panel][type] = checked;
       this.forceUpdate();
    }
    generateReport(){
        let self = this;
        let qs = require("qs"),
        params = {};
        if(self.props.app.state._is_invited === true){
            params = { 
                _id_report : self.props.app.state.report_context._id,
                _email : self.props.app.state.mode_report._email,
                _reports : self.state.type_report_status
            }
        }else{
            params = { 
                _id_report : self.props.app.state.report_context._id,
                _email : localStorage.getItem('email'),
                _reports : self.state.type_report_status,
                api_token: localStorage.getItem("api_token")
            }
        }
        axios({
            method : 'post',
            url : (self.props.app.state._is_invited === true ? (postUrlReportsInsecure + "/export") : (postUrlReports + "/export")),
            data :  qs.stringify(params)
        }).then(function (response){
            message.info('We have sent a message to your email with the download link');
            self.onClose()
        })
    }
    
    render = () => {
        
        let self = this,
        Panel = Collapse.Panel,
        report_props = this.state.type_report;

        let content_reports = (
            <table className="dashboard-report">
                <tbody>
                {
                    Object.keys(report_props).map(function(key){
                        const _is_disabled = false;
                        return (
                            <tr>
                                <td>
                                    <span>
                                        {report_props[key].name}
                                        {(_is_disabled === true) ? 
                                            (<Tag style={{ 
                                                background: '#fff', 
                                                borderStyle: 'dashed', 
                                                marginLeft : 10,
                                                fontStyle : 'italic' }}>NEXT UPDATE</Tag>) : ''}
                                    </span>
                                </td>
                                <td>
                                    Export <Switch
                                        checkedChildren={<Icon type="check" />} 
                                        unCheckedChildren={<Icon type="close" />}
                                        checked={self.state.type_report_status[key].status} 
                                        onChange={self.activateDashboard.bind(self, key, 'status')}
                                        disabled={_is_disabled} 
                                        />
                                    {
                                        (report_props[key].value !== "pickup") ? (
                                            <span className="unfolded" style={{marginLeft : "15px", display : 'none'}}>
                                                <Radio.Group buttonStyle="solid" defaultValue={self.state.type_report_status[key].type} size="small" disabled={(self.state.type_report_status[key].status === true) ? false : true} onChange={(state) =>{
                                                    self.state.type_report_status[key].type = state.target.value
                                                }}>
                                                    <Radio.Button value="normal">Normal</Radio.Button>
                                                    <Radio.Button value="detailed">Detailed</Radio.Button>
                                                </Radio.Group>
                                            </span>
                                        ) : ""
                                    }
                                    
                                </td>
                            </tr>
                        )
                    })
                }
                </tbody>                    
            </table>
        )
        const content_download = (
            <div className="step-download">
                <Radio.Group defaultValue="a" buttonStyle="solid" style={{display : 'none'}}>
                    <Radio value="a"><Icon type="file-excel" style={{ fontSize : 14 }}/> EXCEL</Radio>
                    <Radio value="b" disabled="true"><Icon type="file-pdf" style={{ fontSize : 14 }} /> PDF</Radio>
                </Radio.Group>
                <div className="btn-download">
                    <p style={{
                        color : '#a2a2a2',
                        marginTop : 20,
                        marginBottom : 0,
                        fontStyle : 'italic'
                    }}>NOTE: THE REPORT WILL BE GENERATED AND SENT TO YOUR EMAIL.</p>
                    <Button type="default" icon="left" style={{marginRight : 15, letterSpacing : 1}} onClick={self.prev.bind(this)}>BACK</Button>
                    <Button type="primary" icon="download" style={{marginRight : 15, letterSpacing : 1}} onClick={this.generateReport.bind(this)}>SEND</Button>
                </div>
            </div>
        )
        const Step = Steps.Step;

        const steps = [{
                title: 'CHOOSE REPORTS',
                content: (
                    <div>
                        <div>
                            {content_reports}
                        </div>
                        <Popconfirm placement="bottom" title="Are you sure to cancel exportation？" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={self.onClose.bind(this)}>
                            <Button type="danger" className="next-step" style={{marginRight : 15}}>
                                CANCEL <Icon type="close" />
                            </Button>
                        </Popconfirm>
                        <Button type="primary" className="next-step" onClick={self.next.bind(this)}>
                            NEXT <Icon type="right" />
                        </Button>
                    </div>
                ),
            }, {
                title: 'CHOOSE FORMAT',
                content: content_download
            }
        ];
        return(
            <Drawer
                title="EXPORT REPORT"
                placement="left"
                closable={false}
                onClose={this.onClose}
                visible={this.state.visible}
                maskClosable={false}
                className="accordion-download-report" 
                width={'100%'}>
                    <Row>
                        <Col span={12} offset={6}>
                            <Steps current={this.state.current}>
                                {steps.map(item => <Step key={item.title} title={item.title} />)}
                            </Steps>
                            <div className="steps-content">{steps[this.state.current].content}</div>
                        </Col>
                    </Row>                        
            </Drawer>
        )
    }
}

export default ExportReport;



// WEBPACK FOOTER //
// ./src/Frontend/reports/ExportReport.js